import React from 'react';
import { Input as AntInput } from 'antd';
import { t } from '../../i18n/i18n';
import './TextArea.scss';

const { TextArea: AntTextArea } = AntInput;

export default function TextArea({
  label,
  placeholder,
  value,
  onChange,
  name,
  error,
  required,
  disabled,
  hint,
  rows = 3,
  variant = 'default',
  className = '',
  ...props
}) {
  return (
    <div
      className={`reusable-textarea-group ${variant === 'form' ? 'reusable-textarea-group--form' : ''} ${error ? 'has-error' : ''} ${disabled ? 'is-disabled' : ''}`}
    >
      {label && (
        <label className="reusable-textarea-label">
          {t(label)}
          {required && <span className="reusable-textarea-required">*</span>}
        </label>
      )}
      <AntTextArea
        className={`reusable-antd-textarea ${variant === 'form' ? 'reusable-antd-textarea--form' : ''} ${className}`}
        placeholder={t(placeholder)}
        value={value}
        onChange={onChange}
        name={name}
        rows={rows}
        disabled={disabled}
        required={required}
        status={error ? 'error' : ''}
        {...props}
      />
      {hint && <span className="reusable-textarea-hint">{t(hint)}</span>}
      {error && <span className="reusable-textarea-error-text">{t(error)}</span>}
    </div>
  );
}
